import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { SessionServiceInterface, SessionServiceStateType } from '@central-products/interface-session-service';
import { SessionManagerStateType } from '@central-products/interface-session-manager';
import { HTTPError } from './libs';
export var SessionService = /*#__PURE__*/function (_SessionServiceInterf) {
  _inherits(SessionService, _SessionServiceInterf);

  var _super = _createSuper(SessionService);

  function SessionService(config, dependencies) {
    var _this;

    _classCallCheck(this, SessionService);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", SessionServiceStateType.SESSION_UNKNOWN);

    _defineProperty(_assertThisInitialized(_this), "onStateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "abortController", void 0);

    _defineProperty(_assertThisInitialized(_this), "processSessionManagerState", function (_ref) {
      var state = _ref.state;

      if (state === SessionManagerStateType.LOGGED_IN) {
        _this.processLoggedInState();
      }

      if (state === SessionManagerStateType.NOT_LOGGED_IN) {
        _this.processNotLoggedInState();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setState", function (state) {
      if (_this.state === state) {
        return;
      }

      _this.state = state;

      if (_this.onStateChangedCallback) {
        _this.onStateChangedCallback({
          state: state
        });
      }
    });

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(SessionService, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var sessionManagerState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.dependencies['session-manager'].getState();

              case 2:
                sessionManagerState = _context.sent;
                this.dependencies['session-manager'].onStateChanged(this.processSessionManagerState);
                this.processSessionManagerState(sessionManagerState);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", {
                  state: this.state
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.onStateChangedCallback = callback;
    }
  }, {
    key: "processLoggedInState",
    value: function () {
      var _processLoggedInState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.state !== SessionServiceStateType.SESSION_UNKNOWN && this.state !== SessionServiceStateType.NO_SESSION)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (!this.config.enableSessionManagerProxyMode) {
                  _context3.next = 5;
                  break;
                }

                this.setState(SessionServiceStateType.SESSION_EXISTS);
                return _context3.abrupt("return");

              case 5:
                _context3.prev = 5;
                this.setState(SessionServiceStateType.SESSION_REQUESTED);
                _context3.next = 9;
                return this.initSession();

              case 9:
                this.setState(SessionServiceStateType.SESSION_EXISTS);
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](5);
                this.setState(SessionServiceStateType.NO_SESSION);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 12]]);
      }));

      function processLoggedInState() {
        return _processLoggedInState.apply(this, arguments);
      }

      return processLoggedInState;
    }()
  }, {
    key: "processNotLoggedInState",
    value: function () {
      var _processNotLoggedInState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var previousState;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.state === SessionServiceStateType.NO_SESSION)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                if (!this.config.enableSessionManagerProxyMode) {
                  _context4.next = 5;
                  break;
                }

                this.setState(SessionServiceStateType.NO_SESSION);
                return _context4.abrupt("return");

              case 5:
                if (!(this.state === SessionServiceStateType.SESSION_UNKNOWN)) {
                  _context4.next = 8;
                  break;
                }

                this.setState(SessionServiceStateType.NO_SESSION);
                return _context4.abrupt("return");

              case 8:
                if (this.state === SessionServiceStateType.SESSION_REQUESTED) {
                  if (this.abortController) {
                    this.abortController.abort();
                    this.abortController = undefined;
                  }
                }

                previousState = this.state;
                _context4.prev = 10;
                _context4.next = 13;
                return this.destroySession();

              case 13:
                this.setState(SessionServiceStateType.NO_SESSION);
                _context4.next = 19;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](10);
                this.setState(previousState);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[10, 16]]);
      }));

      function processNotLoggedInState() {
        return _processNotLoggedInState.apply(this, arguments);
      }

      return processNotLoggedInState;
    }()
  }, {
    key: "initSession",
    value: function () {
      var _initSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$this$dependenc, sessionToken, response;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.dependencies['session-manager'].getSessionToken({
                  serviceUrl: "".concat(this.config.sessionServiceUrl, "/handle")
                });

              case 2:
                _yield$this$dependenc = _context5.sent;
                sessionToken = _yield$this$dependenc.sessionToken;
                this.abortController = new AbortController();
                _context5.next = 7;
                return fetch("".concat(this.config.sessionServiceUrl, "/handle?ticket=").concat(sessionToken), {
                  credentials: 'include',
                  signal: this.abortController.signal
                });

              case 7:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 10;
                  break;
                }

                throw new HTTPError(response);

              case 10:
                return _context5.abrupt("return", true);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function initSession() {
        return _initSession.apply(this, arguments);
      }

      return initSession;
    }()
  }, {
    key: "destroySession",
    value: function () {
      var _destroySession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetch("".concat(this.config.sessionServiceUrl, "/logout"), {
                  credentials: 'include'
                });

              case 2:
                response = _context6.sent;

                if (!(response.status > 400)) {
                  _context6.next = 5;
                  break;
                }

                throw new HTTPError(response);

              case 5:
                return _context6.abrupt("return", true);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function destroySession() {
        return _destroySession.apply(this, arguments);
      }

      return destroySession;
    }()
  }]);

  return SessionService;
}(SessionServiceInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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